/** אמצעי תשלום בזרימת לקוח — עמוד packages/profile (מקור אמת יחיד ל־UI). */
export const PACKAGE_PROFILE_PAYMENT_CREDIT = "credit";
export const PACKAGE_PROFILE_PAYMENT_BANK_TRANSFER = "bank_transfer";

export const CREDIT_PAY_NOW_LABEL = "שלם עכשיו";
export const CREDIT_PAY_NOW_LOADING_LABEL = "פותחים תשלום מאובטח...";
export const CREDIT_PAY_PROCESSING_LABEL = "מבצע את התשלום...";

/**
 * Public / customer checkout: one CTA that creates the HYP link and opens pay
 * in the same page (iframe). Agent copy-link UX stays on "צור קישור תשלום".
 */
export function shouldInstantOpenCreditPay({
  focusPayLayout = false,
  isCustomerLink = false,
} = {}) {
  return Boolean(focusPayLayout || isCustomerLink);
}

export function creditPayCreateActionLabel({ instantOpenPay, createLinkLabel }) {
  return instantOpenPay ? CREDIT_PAY_NOW_LABEL : createLinkLabel;
}

export function creditPayCreateLoadingLabel({ instantOpenPay, createLinkLabel }) {
  return instantOpenPay ? CREDIT_PAY_NOW_LOADING_LABEL : createLinkLabel;
}

/**
 * מפעיל את פעולת האשראי הראשונית בטופס (קישור תשלום או פתיחת iframe), לשימוש מסרגל צד/פוטר.
 * @returns {boolean} true אם נמצא אלמנט ונלחץ
 */
export function triggerPackageProfileCreditPay() {
  const openPay = document.querySelector(
    "button.package-payment-credit-open-pay:not(.ant-btn-disabled)"
  );
  if (openPay) {
    openPay.click();
    return true;
  }
  const createLink = document.querySelector(".package-payment-credit-create-link");
  if (createLink) {
    createLink.click();
    return true;
  }
  return false;
}
